/* global require */
import locale from "locale"; // window global

import Vue from "vue";
import moment from "moment";
import { trans, } from "common/translate.js";

export default Vue.component("image-result", {
  props: ["name", "url", "photoType", "date", "index", "side", "pamNumber", "plateNumbers", "frag", "numComments"],

  data() {
    return {
      trans
    }
  },

  computed: {
    formattedDate() {
      return moment(this.date).locale(locale).format("MMMM YYYY");
    },
    commentNumLoaded() {
      return this.numComments !== undefined;
    },
    imageStyle() {
      return {
        "background-image": `url(${this.url.replace("http://", "https://")})`
      };
    },
    plateNumbersAsString() {
      return this.plateNumbers.join(", ") + (this.frag !== null ? `, Frag. ${this.frag}` : "");
    }
  },

  template: require("./templates/image-result.html")
});




// WEBPACK FOOTER //
// ./src/frontend/pages/explore-the-archive/archive/image-result.js